module.exports = __webpack_public_path__ + "img/proteinasImage.7cbbf716.svg";